$(function () {
  $(".thumb").on("click", function () {
    $(this).nextAll(".popup").fadeIn(500);
  });
  $(".close").on("click", function () {
    $(this).parents(".popup").fadeOut(500);
  });
});
